export const MEDIA_GALLERY = {
    GET_MEDIA_GALLERY: "GET_MEDIA_GALLERY",
    DELETE_MEDIA: "DELETE_MEDIA",
    RENAME_MEDIA: "RENAME_MEDIA",
    UPLOAD_MEDIA: "UPLOAD_MEDIA",
    ASSET_MAP:"ASSET_MAP"
};
